import { Component } from '@angular/core';
import { ORCIDExternalIdentifierEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'External Identifiers') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidexternalidentifier-form',
    templateUrl: './orcidexternalidentifier.form.component.html'
})
export class ORCIDExternalIdentifierFormComponent extends BaseFormComponent {
    public record!: ORCIDExternalIdentifierEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

